export const blockIconsPlacesAllInclusive = (
	<span className='material-symbols-outlined'>all_inclusive</span>
);
